import crossFetch from 'cross-fetch';
import {
  semanticSearchRetrieveApiResponseSchema,
  SemanticSearchRetrieveQuery,
} from '../types';
import { ResponseError } from '@backstage/errors';
import { SemanticSearchApi } from './SemanticSearchApi';

// these are isomorphic types that don't require @backstage/core-plugin-api
type DiscoveryApi = { getBaseUrl(pluginId: string): Promise<string> };
type FetchApi = { fetch: typeof fetch };

export class SemanticSearchClient implements SemanticSearchApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  public constructor(deps: {
    discoveryApi: DiscoveryApi;
    fetchApi?: FetchApi;
  }) {
    const { discoveryApi, fetchApi } = deps;
    this.discoveryApi = discoveryApi;
    this.fetchApi = fetchApi ?? { fetch: crossFetch };
  }

  public async retrieve(query: SemanticSearchRetrieveQuery) {
    if (!query.text) {
      return [];
    }
    const baseUrl = await this.discoveryApi.getBaseUrl('search');
    const response = await this.fetchApi.fetch(`${baseUrl}/retrieve`, {
      method: 'POST',
      body: JSON.stringify(query),
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
    });
    if (!response.ok) {
      throw await ResponseError.fromResponse(response);
    }
    const data = await response.json();
    const locations = new Set<string>();
    const results = semanticSearchRetrieveApiResponseSchema
      .parse(data)
      .results.filter(result => {
        if (locations.has(result.location)) {
          return false;
        }
        locations.add(result.location);
        return true;
      });
    return results;
  }
}
